export const LOGIN_LAYOUTS = [
  { id: 'centered', title: 'Centralizado', description: 'Um acesso direto, com formulário central e poucas distrações.' },
  { id: 'split', title: 'Tela dividida', description: 'Identidade em destaque ao lado do formulário em telas amplas.' },
  { id: 'glass', title: 'Cartão de vidro', description: 'Uma superfície translúcida sobre um fundo com a cor do Office.' },
  { id: 'editorial', title: 'Editorial', description: 'Composição minimalista com tipografia e detalhes geométricos.' },
];
export const LOGIN_APPEARANCE_DEFAULTS = { login_layout: 'centered', login_show_brand: true, login_background_light: '', login_background_dark: '' };
export const LOGIN_HEX = /^#[0-9a-fA-F]{6}$/;
export function normalizeLoginAppearance(value = {}) {
  const source = value && typeof value === 'object' ? value : {};
  return {
    login_layout: LOGIN_LAYOUTS.some(item => item.id === source.login_layout) ? source.login_layout : 'centered',
    login_show_brand: typeof source.login_show_brand === 'boolean' ? source.login_show_brand : true,
    ...Object.fromEntries(['light', 'dark'].map(theme => {
      const key = `login_background_${theme}`, color = source[key];
      return [key, typeof color === 'string' && LOGIN_HEX.test(color) ? color.toLowerCase() : ''];
    })),
  };
}
export function loginAppearanceStyle(value, theme) {
  const color = normalizeLoginAppearance(value)[theme === 'dark' ? 'login_background_dark' : 'login_background_light'];
  return color ? { '--login-office-background': color } : {};
}
